<template>
  <div>
    <div class="pg-cab">
      <div class="col">
        <span class="tag">Área de atuação</span>
        <h1>Cobertura</h1>
        <p class="sub">
          Operamos a partir de {{ OPERACAO.base }}, atendendo {{ OPERACAO.areaAtuacao }}.
          Coleta e entrega no mesmo dia mediante confirmação até {{ OPERACAO.limitePedido }}.
        </p>
      </div>
    </div>

    <CoberturaSecao />

    <section class="sec">
      <div class="col grade">
        <div>
          <h2 class="sec-h2">Como o prazo é definido</h2>
          <p class="sec-p tx">
            Não publicamos tempo fixo por município porque o prazo real depende de rota,
            horário de coleta, trânsito e tipo de carga. O prazo da sua entrega é informado
            junto com o valor, antes da coleta — e vale para aquele frete.
          </p>
          <p class="sec-p tx">
            Cidades fora desta lista são atendidas sob consulta, desde que dentro de uma
            distância operacionalmente viável a partir de {{ OPERACAO.base }}.
          </p>
          <router-link to="/solicitar" class="btn btn--azul mt">
            Consultar minha rota <span class="seta">→</span>
          </router-link>
        </div>

        <div class="painel-lado">
          <div class="painel-h"><b class="painel-t">Parâmetros de operação</b></div>
          <div class="dado-l"><span class="k">Base</span><span class="v">{{ OPERACAO.base }}</span></div>
          <div class="dado-l"><span class="k">Área</span><span class="v">{{ OPERACAO.areaAtuacao }}</span></div>
          <div class="dado-l"><span class="k">Janela de coleta</span><span class="v forte">{{ OPERACAO.janelaColeta }}</span></div>
          <div class="dado-l"><span class="k">Pedidos até</span><span class="v">{{ OPERACAO.limitePedido }}</span></div>
          <div class="dado-l"><span class="k">Atendimento</span><span class="v">{{ OPERACAO.atendimento }}</span></div>
          <div class="dado-l"><span class="k">Municípios listados</span><span class="v">{{ COBERTURA.length }}</span></div>
          <p class="aviso">{{ RESTRICOES }}</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import CoberturaSecao from '@/components/CoberturaSecao.vue'
import { COBERTURA, OPERACAO, RESTRICOES } from '@/config/operacao'
</script>

<style scoped>
.cabeca { border-bottom: 1px solid var(--fio); padding: 128px 0 40px; background: var(--nevoa); }
.cabeca h1 {
  font-family: 'Archivo', sans-serif;
  font-weight: 900;
  font-size: clamp(32px, 4vw, 54px);
  letter-spacing: -.045em;
  line-height: 1;
  margin-top: 12px;
}
.sub { margin-top: 16px; font-size: 16px; line-height: 1.6; color: var(--grafite); max-width: 560px; }

.grade { display: grid; grid-template-columns: 1.3fr 1fr; gap: 56px; align-items: start; }
.tx { max-width: 520px; margin-top: 14px; }
.mt { margin-top: 26px; }
.ficha { border: 1px solid var(--fio); border-radius: var(--r); box-shadow: var(--sombra); background: var(--papel-2); padding: 22px 24px 24px; }

@media (max-width: 900px) {
  .grade { grid-template-columns: 1fr; gap: 34px; }
  .tx { max-width: none; }
}
</style>
